export default __webpack_public_path__ + "static/media/ROAMES World - Quick Start Guide.2ec6eeea.pdf";